export function useColors() {
  return useNuxtApp().$colors
}
